import { handleActions } from 'redux-actions';
import { NAMES as SERVER_PAYMENTS_PAYPAL_GET } from 'shared/redux/server/actions/payments/paypal/check-connection';
import { NAMES as SERVER_PAYMENTS_PAYPAL_DISCONNECT } from 'shared/redux/server/actions/payments/paypal/disconnect';


const getResponseData = (state, { payload }) => payload.response.data;

export default handleActions({
  [SERVER_PAYMENTS_PAYPAL_GET.SUCCESS]: getResponseData,
  [SERVER_PAYMENTS_PAYPAL_DISCONNECT.SUCCESS]: getResponseData,
}, null);



// WEBPACK FOOTER //
// ./src/shared/redux/client/reducers/payments/paypal.js